import { SxProps, Theme } from "@mui/material";

export const modalBoxStyles: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  boxShadow: 24,
  background: "none",
  width: { xs: "90%", sm: "90%", md: "90%" },
};

export const headerBoxStyles: SxProps<Theme> = (theme) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: { xs: 1, sm: 2 },
  minWidth: 0,
  background: theme.palette.modalColors.headerColor,
  paddingY: "16px",
  paddingX: { xs: "16px", sm: "38px" },
  borderTopLeftRadius: "16px",
  borderTopRightRadius: "16px",
});

export const headerRightBoxStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: { xs: "12px", sm: "30px" },
  flex: "0 1 auto",
  minWidth: 0,
};

export const contentBoxStyles: SxProps<Theme> = (theme) => ({
  display: "flex",
  gap: "16px",
  flexDirection: "column",
  backgroundColor: theme.palette.modalColors.bgColor,
  padding: "22px",
  borderBottomLeftRadius: "16px",
  borderBottomRightRadius: "16px",
  overflowY: "auto",
  maxHeight: { xs: "80dvh", sm: "80dvh", md: "80dvh" },
});

export const rowStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  gap: "16px",
};
